export const COLUMN_WIDTH = {
  AUTHOR: 200,
} as const
